import Img from "./Img";
import { DocType } from "../../utils/constants/documents";
import useThumbnail from "../../hooks/use-thumbnail";
import Spinner from "./Spinner";
import styles from "./DocumentThumbnail.module.css";
import { SignatureContratStatus } from "../../models/signatureElectronique";

export default function DocumentThumbnail({
  documentId,
  downloadUrl,
  file,
  doctype = DocType.GENERIC_FILE,
  isSigned = file?.signature_electronique_status ===
    SignatureContratStatus.Archived.status,
  onDelete,
  style,
  fallback,
}) {
  let { thumbnail, isLoading } = useThumbnail({
    downloadUrl,
    documentId: file?.thumbnail ? null : documentId,
    doctype,
    isSigned,
  });
  const deleteHandler =
    onDelete &&
    file &&
    ((e) => {
      e.stopPropagation();
      onDelete(file);
    });
  if (isLoading) return <Spinner />;

  return (
    <Img
      b64data={file?.thumbnail}
      blob={thumbnail}
      alt="aperçu document"
      fallback={fallback ? fallback : file?.filename || file?.src}
      cover
      onDelete={deleteHandler}
      className={styles.thumbnail}
      style={style}
    />
  );
}
